<template>
  <div class="container">
    <content-header :data="[{text:'红包一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <router-link to="/redenvelope/new">
            <el-button type="primary" icon="plus" v-permission="['redenvelope.create']">添加</el-button>
          </router-link>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入名称关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-entry">
          <el-select v-model="status" clearable value-key="id" placeholder="请选择状态" @change="searchHandle">
            <el-option
              v-for="item in statusIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <el-select v-model="categoryId" clearable value-key="id" placeholder="请选择类型" @change="searchHandle">
            <el-option
              v-for="item in categoryIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <span>红包创建时间</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="红包编号"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="红包名称"
            width="200"
            fixed>
          </el-table-column>
          <el-table-column
            label="封面图">
            <template slot-scope="scope">
            <img style="width:50px;height:50px" :src="domainPic + scope.row.image" v-if="scope.row.image" />
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="活动开始时间"
            width="180">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="活动结束时间"
            width="180">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
          </el-table-column>
          <el-table-column
            prop="money"
            label="金额">
          </el-table-column>
          <el-table-column
            prop="openCount"
            label="领取人次">
          </el-table-column>
          <el-table-column
            label="总金额">
            <template slot-scope="scope">
            <span>{{scope.row.money*scope.row.openCount}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" v-permission="['redenvelope.update']">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" v-permission="['redenvelope.delete']">删除</el-button>
              <el-button @click="activeHandle(scope)" type="text" size="small" v-permission="['redenvelope.delete']">{{ scope.row.isActive == 1 ? '暂停' : '重启' }}</el-button>
              <el-button @click="downloadHandle(scope)" type="text" size="small" v-permission="['redenvelope.qrcode']">下载二维码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改红包' : '添加红包'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="品牌名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="logo" label="LOGO" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.logo" :src="domainPic + curObj.logo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
              <ky-editor v-model="curObj.description"
                ref="myQuillEditor">
              </ky-editor>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import date from 'utils/date'
  import RedEnvelopeModel from 'models/redenvelope'
  import CommonModel from 'models/common'
  import KyEditor from 'components/KyEditor'
  import permission from 'directive/permission/index.js'

  export default {
    directives: { permission },
    components: {
      KyEditor,
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        keywords: '',
        tableData: [],
        isObjShow: false,
        curObj: {
          id: '',
          name: '',
          image: '',
        },
        formLabelWidth: '80px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
        },
        curPage: 1,
        pageSize: 10,
        total: 0,
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        //
        categoryId: '',
        categoryIds: [],
        status: '',
        statusIds: [{id: '1', name: '未开始'}, {id: '2', name: '进行中'}, {id: '3', name: '已结束'}],
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      RedEnvelopeModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        this.categoryIds = res.rows
      })
      this.getObjList()
    },
    methods: {
      //
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.logo = response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'brand'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'brand'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log(this.uploadForm)
        }
        return true
      },
      //
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords,
          status: this.status,
          categoryId: this.categoryId,
          startDate: this.startDate,
          endDate: this.endDate
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        RedEnvelopeModel.find(_opts).then(res => {
          for (let i = 0; i < res.rows.length; i++) {
            let start = new Date(res.rows[i].startTime.replace(/-/g, '/'))
            let end = new Date(res.rows[i].endTime.replace(/-/g, '/'))
            let now = new Date()
            if (start > now) {
              res.rows[i].status = '未开始'
            } else if (start <= now && now <= end) {
              res.rows[i].status = '进行中'
            } else {
              res.rows[i].status = '已结束'
            }
            if (res.rows[i].isActive === 0) {
              res.rows[i].status = '暂停'
            }
          }
          this.tableData = res.rows
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            RedEnvelopeModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      activeHandle (item) {
        this.$confirm(!item.row.isActive ? '重启活动？' : '暂停活动？暂停后无法领取红包')
          .then(_ => {
            console.log('ok')
            RedEnvelopeModel.activate({
              id: item.row.id,
              isActive: item.row.isActive === 0 ? 1 : 0
            }).then(() => {
              item.row.isActive = item.row.isActive === 0 ? 1 : 0
              let start = new Date(item.row.startTime.replace(/-/g, '/'))
              let end = new Date(item.row.endTime.replace(/-/g, '/'))
              let now = new Date()
              if (start > now) {
                item.row.status = '未开始'
              } else if (start <= now && now <= end) {
                item.row.status = '进行中'
              } else {
                item.row.status = '已结束'
              }
              if (item.row.isActive === 0) {
                item.row.status = '暂停'
              }
              this.$message({ message: item.row.isActive === 1 ? '重启成功' : '暂停成功', type: 'success' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: '',
          image: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        RedEnvelopeModel.create({
          name: this.curObj.name,
          image: this.curObj.image,

        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'redenvelope.new',
          query: { id: item.row.id }
        })
      },
      editHandle () {
        RedEnvelopeModel.update({
          id: this.curObj.id,
          name: this.curObj.name,
          image: this.curObj.image,
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
      downloadHandle (item) {
        this.$router.push({
          name: 'redenvelope.qrcode',
          query: {redEnvelopeId: item.row.id, type: 2}
        })
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/RedEnvelope.vue